'use strict';

var SystemConstants = {
  SCREEN_VALUE: {
    SYSTEM_CONFIG: {
      SYSTEM_PARAMETER: 'system-parameters',
      SYSTEM_PARAMETER_ADVANCED_HEP: 'system-parameters-advanced-hep',
      MARKET_CLASS_FARE: 'market-class-fare',
      BUDGET_TARGET: 'budget-target',
      MARKET_ASSIGN: 'market-assignments',
      FLIGHT_ASSIGNMENT: 'flight-assignments',
      ENTITY: 'entity',
      LEG_ASSIGNMENT: 'leg-assignments',
      HOST_SHARE: 'host-market-share',
      EVENTS: 'events',
      FLIGHT_TAG: 'flight-tag',
      DISCONTINUED_ROUTES: 'discontinued-routes',
      USER_DEFINED_REF_DATA: 'user-defined-ref-data',
      WEB_FARE: 'web-fare',
      SURCHARGE_UPLOAD: 'fares-surcharge-upload',
      MARKET_CLASS_FARE_INFLUENCES: 'market-class-fare-influences',
      LINKED_FBC: 'fo-linked-fbc',
      FARE_BUILDER: 'fo-fare-builder'
    },
    SYSTEM_STATUS: {
      FLIGHT_SENT: 'flight-sent',
      SERVICE_SENT: 'service-sent',
      REOPTIMIZATION: 'reoptimization',
      REINITIALIZATION: 'reinitialization',
      OVERBOOKING: 'overbooking',
      FLIGHT_REOPT: 'flight-reopt',
      MARKET_REOPT: 'market-reopt',
      FO_FARES_REOPT: 'fares-reopt',
      HISTORY: 'history',
      HISTORY_MODE: {
        MARKET: 'system-status-history-market',
        FLIGHT: 'system-status-history-flight',
        SERVICE: 'system-status-history-service',
        FARES: 'system-status-history-fares'
      },
      INTERFACE_STATUS: 'system-status-interface-status'
    },
    USER_EXCLUSIONS: {
      EXCLUSION_RULES: 'user-exclusion-rules',
      FBC_EXCLUSION_RULES: 'user-fbc-exclusion-rules',
      FARE_EXCLUSION_RULES: 'user-fare-exclusion-rules'
    },
    COMPONENT: {
      FLIGHT_SENT: 'flight-sent',
      SERVICE_SENT: 'service-sent',
      REOPT: 'reopt',
      FLIGHT_OPTIMIZATION: 'flight-optimization',
      MARKET_OPTIMIZATION: 'market-optimization',
      DEMAND_INITIALIZATION: 'demand-initialization',
      OVERBOOKING_INITIALIZATION: 'overbooking-initialization',
      HISTORY: 'history',
      FARES_REOPTIMIZATION: 'fares-reoptimization',
      INTERFACE_STATUS: 'interface-status'
    }
  }
};
module.exports = SystemConstants;